<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    item-text="key"
    item-value="key"
    :label="label"
    :clearable="clearable"
    hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ItemKindModel} from "@/modules/redactor/models/item/core/ItemKindModel";

export default {
  name: "r-item-kind-dropdown",

  props: {
    model: VueTypes.instanceOf(ItemKindModel),
    label: VueTypes.string.def("Item Kind"),
    clearable: VueTypes.bool.def(false)
  },

  data() {
    return {
      items: [],
      selected: null
    };
  },

  watch: {
    model: {
      handler(newVal) {
        this.selected = newVal?.key ?? "none";
      },
      immediate: true
    },

    selected(newKey) {
      const item = this.items.find(item => item?.key === newKey);

      if (!item) {
        const noneItem = this.items.find(i => ItemKindModel.isNone(i));
        this.$emit("update:model", noneItem);
      } else {
        this.$emit("update:model", item);
      }
    }
  },

  created() {
    this.initializeItems();
  },

  methods: {
    initializeItems() {
      const mapCode = RedactorUtils.getCurrentMapKind()?.code;
      const allItems = RedactorUtils.getItemKinds();

      this.items = (mapCode && mapCode !== 9999)
        ? allItems.filter(i => ItemKindModel.isNone(i) || i?.maps?.includes(mapCode))
        : allItems;

      const hasNone = this.items.some(i => ItemKindModel.isNone(i));
      if (!hasNone) {
        const noneObj = RedactorUtils.getItemKindByKey?.("none") ||
          allItems.find(i => ItemKindModel.isNone(i));
        if (noneObj) {
          this.items.unshift(noneObj);
        }
      }

      if (!this.model?.key || ItemKindModel.isEmpty(this.model.key)) {
        const noneItem = this.items.find(i => ItemKindModel.isNone(i));
        if (noneItem) {
          this.$emit("update:model", noneItem);
        }
      }
    }
  }
};
</script>